<template style="height: 100%;">
  <div class="Evaluation_statistics">
    <el-form style="background:#fff;height: 60px;padding-top:20px;" :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="单位名称" style="margin-left:20px">
        <el-input v-model="DeptID" placeholder="单位名称"></el-input>
      </el-form-item>
      <el-form-item label="主题" style="margin-left:20px">
        <el-select v-model="PublishID" placeholder="请选择主题" @change="evaluationSituation">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="(item,i) in GetSubjectPublish" :key="i" :label="item.PublishSubject" :value="item.PublishID"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onSubmit(1)">查询</el-button>
        <el-button type="primary" @click="onSubmit(2)">重置</el-button>
      </el-form-item>
    </el-form>
    <div style="width: 100%;height: calc(100% - 95px);background:#fff;margin-top:15px;">
      <el-table v-loading="loadings" :data="tableData" style="width:98%;margin-left:1%;padding-top:15px;">
        <el-table-column label="序号">
          <template slot-scope="scope">
            <span>{{ (pageIndex - 1) * 10 + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="单位编号">
          <template slot-scope="scope">
            <span>{{ scope.row.deptID }}</span>
          </template>
        </el-table-column>
        <el-table-column label="单位名称">
          <template slot-scope="scope">
            <span>{{ scope.row.deptName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="联系人">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        
        <el-table-column label="联系方式">
          <template slot-scope="scope">
            <span>{{ scope.row.phone }}</span>
          </template>
        </el-table-column>

        <el-table-column label="测试总数">
          <template slot-scope="scope">
            <span>{{ scope.row.testTotal }}</span>
          </template>
        </el-table-column>

        <el-table-column label="已完成">
          <template slot-scope="scope">
            <span>{{ scope.row.completed }}</span>
          </template>
        </el-table-column>

        <el-table-column label="未完成">
          <template slot-scope="scope">
            <span>{{ scope.row.incomplete }}</span>
          </template>
        </el-table-column>

        <el-table-column label="完成比例">
          <template slot-scope="scope">
            <span>{{ scope.row.testProgress }}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleEdit(scope.row)">通知</el-button>
          </template>
        </el-table-column>

      </el-table>
      <el-pagination @current-change="handleCurrentChange" :page-size="10" :current-page.sync="currentPage1" layout="total, prev, pager, next" :total="Counts"></el-pagination>
      
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      DeptID:'',
      pageIndex: 1,
      tableData: [],
      loadings: false,
      currentPage1: 1,
      Counts:0,
      PublishID:'',
      GetSubjectPublish:'',
    }
  },
  methods: {
    handleEdit(rew){
      this.$Http_Post('/workbench/evaluationStatisticsNotice',{"PublishID":rew.publishID,Phone:rew.phone,roleID:rew.roleID,DeptID:rew.deptID}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
        }else{
          this.Global.request_failure(res.Message);
        }
      })
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.loading();
    },
    onSubmit(type) {
      this.pageIndex = 1;
      if (type !== 1) {
        this.currentPage1 = 1;
        this.DeptID = '';
        this.PublishID = '';
      }
      this.loading();
    },
    loading(){
      this.loadings = true;
      this.$Http_Post('/workbench/evaluationStatisticsList',{DeptID: this.DeptID,pageSize: 10,pageIndex: this.pageIndex,PublishID: this.PublishID}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.loadings = false;
          this.tableData = res.Data;
          this.Counts = res.Counts;
        }
      })
    }
  },
  mounted() {
    this.$Http_Post('/EmphasisClarification/GetSubjectPublish').then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.GetSubjectPublish = res.Data;
      }
    })
    this.loading();
  },
}
</script>
<style>
.Evaluation_statistics{height: 100%;}
</style>
